class MobileNav {
	init() {
		$('[data-toggle-menu]').on('click', this.toggleMobileMenu);
		$('[data-submenu-toggle]').on('click', this.toggleMobileSubMenu);
		$(document).on('load', () => {
			this.vhMobileHeight();
		});
	}

	// Resize vh for mobile menu height
	vhMobileHeight() {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}

	// Toggle mobile menu
	toggleMobileMenu(e: { preventDefault: () => void }) {
		e.preventDefault();
		if ($('body').is('.open-nav')) {
			$('body').removeClass('open-nav');
			$(this).attr('aria-expanded', 'false');
			$(this).attr('title', 'Open main menu');
			$(this).removeClass('main-hamburger-menu--close');
		} else {
			$('body').addClass('open-nav');
			$(this).attr('aria-expanded', 'true');
			$(this).attr('title', 'Close main menu');
			$(this).addClass('main-hamburger-menu--close');
		}
	}

	// Toggle submenus within mobile menu
	toggleMobileSubMenu(e: { preventDefault: () => void }) {
		e.preventDefault();
		const parent = $(this).parent();
		if (parent.is('.open-submenu')) {
			parent.removeClass('open-submenu');
			$(this).attr('aria-expanded', 'false');
		} else {
			parent.addClass('open-submenu');
			$(this).attr('aria-expanded', 'true');
		}
	}
}

export default new MobileNav();
